'use client';

import { ComponentProps, PropsWithChildren, useContext } from 'react';
import { AppConfigContext } from '@/features/app-providers/app-config-provider';
import { AppStore } from '@/shared/ui/app-store';
import { GooglePlay } from '@/shared/ui/google-play';
import { Layout } from '@/shared/ui/layout';

type LayoutProps = ComponentProps<typeof Layout>;

export const FooterAppSection = ({ children, ...props }: PropsWithChildren<LayoutProps>) => {
    const { appLinks, apiPartnerCode } = useContext(AppConfigContext);
    if (apiPartnerCode === 'APPLICATION') return null;
    if (!appLinks?.googlePlay?.trim() && !appLinks?.appStore?.trim()) return null;

    return (
        <Layout data-testid="footer-app-section" {...props}>
            {children}
        </Layout>
    );
};

export const FooterAppLinks = ({ media, ...props }: LayoutProps) => {
    const { appLinks } = useContext(AppConfigContext);
    const googlePlay = appLinks?.googlePlay?.trim();
    const appStore = appLinks?.appStore?.trim();

    return (
        <Layout
            data-testid="footer-app-links"
            media={{
                initial: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '0.5rem',
                    alignItems: 'center',
                    ...media?.initial,
                },
                ...media,
            }}
            {...props}
        >
            {googlePlay && (
                <GooglePlay href={googlePlay} data-testid="footer-app-link" data-value="google-play" />
            )}
            {appStore && (
                <AppStore href={appStore} data-testid="footer-app-link-app" data-value="app-store" />
            )}
        </Layout>
    );
};
